import { Chip, ChipRow } from "../lib/Chip.tsx";
import { FILTER_LABELS } from "./activity.constants.ts";
import type { FilterChip } from "./activity.model.ts";

/**
 * The two stacked axes the reference design puts above the table.
 *
 * `ChipRow`'s label doubles as the group's accessible name, so a screen reader
 * hears "User" or "Action type" before it hears the chip — which is what makes
 * the axes legible at all when the chips are only words.
 *
 * A chip carrying a reason is one that can never match, because the registry
 * records no such act. It renders disabled with the reason attached rather than
 * being dropped: the design was drawn against a wider product, and showing the
 * gap beats quietly narrowing the row and leaving the reader to wonder whether
 * the feature or their data is missing.
 */
export function ActivityFilters({
  users,
  actions,
  onUser,
  onAction,
}: {
  users: FilterChip[];
  actions: FilterChip[];
  onUser: (id: string) => void;
  onAction: (id: string) => void;
}) {
  return (
    <div className="activity__filters">
      <ChipRow label={FILTER_LABELS.user}>
        {users.map((chip) => (
          <Chip key={chip.id} pressed={chip.pressed} onClick={() => onUser(chip.id)}>
            {chip.label}
          </Chip>
        ))}
      </ChipRow>

      <ChipRow label={FILTER_LABELS.action}>
        {actions.map((chip) => (
          <Chip
            key={chip.id}
            pressed={chip.pressed}
            disabled={chip.absent !== null}
            title={chip.absent ?? undefined}
            onClick={() => onAction(chip.id)}
          >
            {chip.glyph ? <span aria-hidden="true">{chip.glyph} </span> : null}
            {chip.label}
          </Chip>
        ))}
      </ChipRow>
    </div>
  );
}
